export default {
  "related.info.title": "関連情報",
  "related.category.title": "カテゴリー",
  "related.about.title": "LINK-Jを知る",
  "related.news.topics": "トピック",
  "related.news.pressRelease": "プレスリリース",
  "related.news.media": "メディア情報",
  "related.news.overseas": "海外関連",
  "related.news.newsEvents": "イベント告知",
  "related.news.program": "アクセラレーション",
  "related.news.sponsorship": "協賛・協力",
  "related.news.list": "ニュース一覧",
  "related.event.all": "",
  "related.event.eventsMain": "LINK-J主催・共催",
  "related.event.coSponsorship": "LINK-J協賛・協力",
  "related.event.memberEvent": "特別会員開催",
  "related.event.archive": "過去イベント",
  "related.event.list": "イベント一覧",
  "related.eventReport.main": "LINK-J主催・共催",
  "related.eventReport.coSponsorship": "LINK-J協賛・協力",
  "related.eventReport.memberEvent": "特別会員開催",
  "related.eventReport.attend": "出展・参加",
  "related.eventReport.list": "イベントレポート一覧",
  "related.sandbox.scoop": "SCOOP",
  "related.sandbox.sandbox": "SANDBOX",
  "related.sandbox.list": "SANDBOX一覧",
  "related.interview.special-interviews": "スペシャルインタビュー",
  "related.interview.start-up-interviews": "ベンチャーインタビュー",
  "related.interview.supporter": "会報誌（News Letter）",
  "related.interview.serial-column": "連載コラム",
  "related.interview.supporter-column": "サポーターコラム",
  "related.interview.column": "日本橋コラム",
  "related.interview.link-j-staff-blog": "事務局だより",
  "related.interview.list": "インタビュー・コラム一覧",
  "related.about.greetings": "理事長挨拶",
  "related.about.why": "Why in Nihonbashi",
  "related.about.overseas": "国内外連携",
  "related.about.message": "応援メッセージ",
  "related.about.supporter": "サポーター紹介",
  "related.about.business.company": "事業内容",
  "related.about.introduction.corporate": "会員・提携先一覧",
  "related.about.business.organization": "組織概要",
  "related.bulletinboard.pressRelease": "会員プレスリリース",
  "related.bulletinboard.news": "ニュース・事業紹介",
  "related.bulletinboard.bulletinBoardsRecruit": "募集",
  "related.bulletinboard.bulletinBoardsEvent": "イベント",
  "related.webpage.greetings": "理事長挨拶",
  "related.webpage.whyInNihonbashi": "Why in Nihonbashi",
  "related.webpage.whatsLinkJWest": "What's LINK-J WEST",
  "related.webpage.domesticAndInternationalCooperation": "国内外連携",
  "related.webpage.supportMessages": "応援メッセージ",
  "related.webpage.supporterIntroduction": "サポーター紹介",
  "related.webpage.businessContents": "事業内容",
  "related.webpage.specialMemberList": "特別会員一覧",
  "related.webpage.organizationOverview": "組織概要",
} as const;
